var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8H13.4L17.924 0.763C18.0193 0.608961 18.0238 0.415445 17.9358 0.257128C17.8478 0.0988114 17.6811 0.000449658 17.5 0H9.5C9.27052 6.33973e-05 9.07054 0.156336 9.015 0.379L6.015 12.379C5.97776 12.5283 6.01136 12.6865 6.10608 12.8078C6.20081 12.929 6.34611 13 6.5 13H9.845L7.018 23.367C6.95324 23.6036 7.06974 23.8523 7.293 23.954C7.5165 24.0516 7.77779 23.9769 7.916 23.776L17.916 8.776C18.0175 8.62262 18.0267 8.42588 17.9398 8.26376C17.8528 8.10165 17.6839 8.00034 17.5 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.7eef52f5.svg";
export { ForwardRef as ReactComponent };